const { getRegexByDocumentType } = require('../../../common/utils/regex');

module.exports = {
  init() {
    const self = this;
    $('.document-type-selector__select').each(
      function eachRegionSelectorSelect() {
        // we will listen to the changes in that selection
        self.listenChangeEvent(this);
        // get selected option and use it to get the value in regex json
        self.updateRegex(this, self.getSelectedOption(this));
      }
    );
  },
  listenChangeEvent(select) {
    const self = this;
    $(select).on('change', function onSelectChange() {
      const selectedOption = self.getSelectedOption(this);
      self.updateRegex(this, selectedOption);
    });
  },
  getSelectedOption(select) {
    const selectedOption = select.options[select.selectedIndex];
    return selectedOption ? selectedOption.value : null;
  },
  updateRegex(select, selected) {
    const $parent = $(select).closest('form');
    const $input = $parent.find('.document-type-selector__input');
    // Update pattern in input field
    $input.attr('pattern', getRegexByDocumentType(selected));
  },
};
